import { productPriceSearchFragment } from '@/graphql/fragments/price';
import { attributeNames } from '@/utils/productProjection';

function includeNames<T extends string[] | readonly string[]>(names: T) {
  const quotedList = names.map((name) => `"${name}"`).join(', ');
  return `includeNames: [${quotedList}]`;
}

/**
 * Selected attributes for common Product Projection Search results
 */
export const productProjectionFragment = `
fragment productProjectionFragment on ProductProjection {
  id
  key
  name(locale: $locale)
}
`;

/**
 * Selected attributes for common Product Projection Search variants
 */
export const productProjectionVariantFragment = `
fragment productProjectionVariantFragment on ProductSearchVariant {
  attributesRaw(${includeNames(attributeNames)}) {
    name
    value
  }
  id
  images {
    url
    label
  }
  prices { ...productPriceSearchFragment }
  sku
}

${productPriceSearchFragment}
`;
